/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import OptionWrapper from "../others/option-wrapper";
import PropTypes from 'prop-types';
import { forwardRef, memo, useImperativeHandle, useMemo, useRef } from 'react';
import { bgColor, border, borderRadius, displayFlex, flexCol, order, overflowAuto, parseWidth, pd, positionRelative } from "../../styles/general";
import { classNames } from "../../utils";
const PopoverBody = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  children,
  className,
  id,
  style
}, reference) => {
  if (!reference) reference = useRef(null);
  const ref = useRef(null);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return useMemo(() => jsx("div", {
    css: PopoverBodyCSS,
    ref: ref,
    id: id,
    style: style,
    className: classNames('DGN-UI-Popover-Body', className)
  }, children), [children, className, id, style]);
}));
const PopoverBodyCSS = css`
    ${displayFlex};
    ${flexCol};
    ${positionRelative};
    ${overflowAuto};
    ${pd([4])};
    ${order(2)};
    &::-webkit-scrollbar {
        ${parseWidth(24)};
    }
    &::-webkit-scrollbar-thumb {
        ${borderRadius(10)};
        mix-blend-mode: normal;
        ${bgColor('fill/scrollbar_rest')};
        background-clip: content-box;
        ${border(8, 'transparent')};
        :hover {
            ${bgColor('fill/scrollbar_hover')};
        }
    }
`;
PopoverBody.defaultProps = {
  className: '',
  style: {}
};
PopoverBody.propTypes = {
  /** The content of the component. */
  children: PropTypes.node,
  /** Class for component. */
  className: PropTypes.string,
  /** Style inline of component. */
  style: PropTypes.object
};
export { PopoverBody };
export default OptionWrapper(PopoverBody);